export const status = ['Заявка отправлена поставщику', 'Получен счет', 'Получен отказ', 'Подготовка документов', 'Сформирован документ покупки', 'Отменен']
export const statusAll = [
  { value: 'created', label: 'Заказ создан', color: '#1976d2' },
  { value: 'send', label: 'Заявка отправлена поставщику', color: '#1976d2' },
  { value: 'invoice', label: 'Получен счет', color: '#2e7d32' },
  { value: 'refused', label: 'Получен отказ', color: '#d32f2f' },
  { value: 'docPreparation', label: 'Подготовка документов', color: '#0288d1' },
  { value: 'doc', label: 'Сформирован документ покупки', color: '#2e7d32' },
  { value: 'canceled', label: 'Отменен', color: '#ed6c02' },
]